<template>
<!--  <div style="max-height: 500px; overflow-y: scroll;">-->
  <div>

    <h6 v-if="!isReadOnly">
      <b-badge variant="secondary">At least one of Rego+State / VIN / Serial No. is mandatory.</b-badge>
    </h6>

    <table class="table table-bordered table-sm" v-if="Array.isArray(this.vehicles) && this.vehicles.length > 0">
      <thead>
      <tr>
        <th class="text-center align-middle p-1" width="3%" rowspan="2"></th>
        <th colspan="2" style="text-align: center; font-weight: bold; font-style: italic; padding: 2px;">
          <b-badge size="sm" variant=""><span class="font-weight-bolder">IF&nbsp;REGISTERED&nbsp;VEHICLE</span></b-badge>
        </th>
        <th class="text-center p-1" width="11%" rowspan="2">VIN</th>
        <th class="text-center p-1" width="6%" rowspan="2">Serial No.</th>
        <th class="text-center p-1" width="14%" rowspan="2">Type<span v-if="!isReadOnly" class="text-danger">*</span></th>
        <th class="text-center p-1" width="8%" rowspan="2">Make<span v-if="!isReadOnly && mandatory" class="text-danger">*</span></th>
        <th class="text-center p-1" width="9%" rowspan="2">Model<span v-if="!isReadOnly && mandatory" class="text-danger">*</span></th>
        <th class="text-center p-1" width="5%" rowspan="2">Year<span v-if="!isReadOnly && mandatory" class="text-danger">*</span></th>
        <th class="text-center p-1" width="9%" rowspan="2">Market&nbsp; Value<span v-if="!isReadOnly" class="text-danger">*</span></th>
        <th colspan="2" style="text-align: center; font-weight: bold; font-style: italic; padding: 2px;">
          <b-badge size="sm" variant=""><span class="font-weight-bolder">BUSINESS LOCATION</span></b-badge>
        </th>
        <th class="text-center p-1" width="8%" rowspan="2">Cover&nbsp; Type</th>
        <th class="text-center p-1" width="2%" rowspan="2"></th>
      </tr>
      <tr>
        <th class="text-center p-1" width="7%">Rego</th>
        <th class="text-center p-1" width="6%">State</th>
        <th class="text-center p-1" width="5%">Postcode<span v-if="!isReadOnly" class="text-danger">*</span></th>
        <th class="text-center p-1" width="6%">State<span v-if="!isReadOnly" class="text-danger">*</span></th>
      </tr>
      </thead>

      <tr v-for="(vehicle, index) in this.vehicles" :key="index">
        <td>
          {{ index + 1 }}
          <i v-if="vehicle.dataMissing" class="fa fa-exclamation-circle text-danger ml-1" v-b-popover.hover.right="'Data Missing'"></i>
        </td>

        <td v-if="isReadOnly">{{ vehicle.Rego }}
          <span v-if="vehicle.NevdisInfo && vehicle.Rego">
            <i class="fas fa-sm fa-info-circle ml-1" v-b-popover.hover.right="vehicle.NevdisInfo"></i>
          </span>
        </td>
        <td v-if="!isReadOnly" class="p-1">
          <ValidationProvider rules="min:2|max:7" :name="`vehicle${index}.Rego`" v-slot="{ errors }">
            <b-form-input size="sm" type="text" maxlength="7" class="form-control text-uppercase" v-model.trim="vehicle.Rego"/>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="isReadOnly" class="text-center">{{ vehicle.State }}</td>
        <td v-if="!isReadOnly" class="p-1">
          <ValidationProvider :rules="{ 'required': !!vehicle.Rego }" :name="`vehicle${index}.State`" v-slot="{ errors }">
            <b-form-select size="sm" class="form-control" v-model="vehicle.State" :disabled="isReadOnly">
              <option value="NSW">NSW</option>
              <option value="VIC">VIC</option>
              <option value="ACT">ACT</option>
              <option value="QLD">QLD</option>
              <option value="WA">WA</option>
              <option value="SA">SA</option>
              <option value="NT">NT</option>
              <option value="TAS">TAS</option>
              <option value="NZ">NZ</option>
            </b-form-select>
            <span class="text-danger"><br>{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="isReadOnly">{{ vehicle.VIN }}
          <span v-if="vehicle.NevdisInfo && vehicle.VIN">
            <i class="fas fa-sm fa-info-circle ml-1" v-b-popover.hover.right="vehicle.NevdisInfo"></i>
          </span>
        </td>
        <td v-if="!isReadOnly" class="p-1">
          <ValidationProvider :rules="{ 'required': isVinMandatory(vehicle), 'min': 17, 'max': 17 }" :name="`vehicle${index}.VIN`" v-slot="{ errors }">
            <b-form-input size="sm" type="text" maxlength="17" class="form-control text-uppercase" v-model.trim="vehicle.VIN"/>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="isReadOnly">{{ vehicle.Serial }}</td>
        <td v-if="!isReadOnly" class="p-1">
          <ValidationProvider :rules="{ 'required': isSerialMandatory(vehicle), 'max': 10 }" :name="`vehicle${index}.Serial`" v-slot="{ errors }">
            <b-form-input size="sm" type="text" maxlength="10" class="form-control text-uppercase" v-model.trim="vehicle.Serial"/>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="isReadOnly"><span v-if="vehicle.Type">{{ vehicle.Type.name }}</span></td>
        <td v-if="!isReadOnly" class="p-1">
          <ValidationProvider rules="required" :name="`vehicle${index}.Type`" v-slot="{ errors }">
            <b-form-select size="sm" class="form-control" v-model="vehicle.Type"
                           :options="vehicleTypes" text-field="Name" value-field="idObject" :disabled="isReadOnly"
            >
            </b-form-select>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="isReadOnly">{{ vehicle.Make }}</td>
        <td v-if="!isReadOnly" class="p-1">
          <ValidationProvider :rules="{ 'required': isMakeModelYearMandatory(vehicle), 'max': 255 }" :name="`vehicle${index}.Make`" v-slot="{ errors }">
            <b-form-input size="sm" type="text" maxlength="255" class="form-control" v-model.trim="vehicle.Make" :disabled="isReadOnly"/>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="isReadOnly">{{ vehicle.Model }}</td>
        <td v-if="!isReadOnly" class="p-1">
          <ValidationProvider :rules="{ 'required': isMakeModelYearMandatory(vehicle), 'max': 255 }" :name="`vehicle${index}.Model`" v-slot="{ errors }">
            <b-form-input size="sm" type="text" maxlength="255" class="form-control" v-model.trim="vehicle.Model" :disabled="isReadOnly"/>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="isReadOnly">{{ vehicle.Year }}</td>
        <td v-if="!isReadOnly" class="p-1">
          <ValidationProvider :rules="{ 'required': isMakeModelYearMandatory(vehicle), 'min': 4, 'max': 4, 'max_value': currentYear }" :name="`vehicle${index}.Year`" v-slot="{ errors }">
            <b-form-input size="sm" type="number" :max="currentYear" minlength="4" maxlength="4" class="form-control" v-model.trim="vehicle.Year" :disabled="isReadOnly"/>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="isReadOnly"><span v-if="vehicle.MarketValue">{{ vehicle.MarketValue | currency("$", ",", 0, ".", "front", true) }}</span></td>
        <td v-if="!isReadOnly" class="p-1">
          <ValidationProvider rules="required" :name="`vehicle${index}.MarketValue`" v-slot="{ errors }">
            <currency-input class="form-control form-control-sm" v-model="vehicle.MarketValue" :disabled="isReadOnly"
                            :allow-negative="false" :distraction-free="false" :precision="0"
            />
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="isReadOnly" class="text-center" style="background-color: lightgray">{{ vehicle.LocationPostcode }}</td>
        <td v-if="!isReadOnly" class="p-1" style="background-color: lightgray">
          <ValidationProvider rules="required|numeric" :name="`vehicle${index}.LocationPostcode`" v-slot="{ errors }">
            <b-form-input size="sm" type="text" minlength="3" maxlength="4" class="form-control" v-model.trim="vehicle.LocationPostcode" :disabled="isReadOnly"/>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="isReadOnly" class="text-center" style="background-color: lightgray">{{ vehicle.LocationState }}</td>
        <td v-if="!isReadOnly" class="p-1" style="background-color: lightgray">
          <ValidationProvider rules="required" :name="`vehicle${index}.LocationState`" v-slot="{ errors }">
            <b-form-select size="sm" class="form-control" v-model="vehicle.LocationState" :disabled="isReadOnly">
              <option value="NSW">NSW</option>
              <option value="VIC">VIC</option>
              <option value="ACT">ACT</option>
              <option value="QLD">QLD</option>
              <option value="WA">WA</option>
              <option value="SA">SA</option>
              <option value="NT">NT</option>
              <option value="TAS">TAS</option>
              <option value="NZ">NZ</option>
            </b-form-select>
            <span class="text-danger"><br>{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="isReadOnly" class="text-center">{{ vehicle.CoverType }}</td>
        <td v-if="!isReadOnly" class="p-1">
          <ValidationProvider name="`vehicle${index}.CoverType`" v-slot="{ errors }">
            <b-form-select class="form-control" v-model="vehicle.CoverType" size="sm" :disabled="isReadOnly">
              <option value="Comprehensive">Comprehensive</option>
              <option value="TPPD">TPPD</option>
            </b-form-select>
            <span class="text-danger">{{ errors[0] }}</span>
          </ValidationProvider>
        </td>

        <td v-if="!isReadOnly" class="align-middle">
          <button class="btn btn-xs btn-icon" style="height: 15px; width: 15px;" @click.prevent="deleteVehicle(index)" title="Delete">
            <i class="fa fa-sm fa-trash text-danger"></i>
          </button>
        </td>
      </tr>

      <tr v-if="!isReadOnly">
        <td colspan="13" class="text-center">
          <button class="btn btn-sm btn-primary col-2" @click.prevent="addVehicle">
            <i class="fa fa-plus"></i> Add Another Vehicle
          </button>
        </td>
      </tr>
    </table>
  </div>
</template>

<style lang="scss">
</style>

<script>

export default {
  name: 'VehiclesList',

  props: {
    vehicles: Array,
    vehicleTypes: Array,
    isReadOnly: {
      type: Boolean,
      default: true
    },
    mandatory: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {};
  },

  mounted() {},

  computed: {
    currentYear: function () {
      return new Date().getFullYear();
    }
  },

  methods: {
    addVehicle: function () {
      this.vehicles.push({ CoverType: 'Comprehensive'});
    },

    deleteVehicle: function (index) {
      this.vehicles.splice(index, 1);
    },

    isVinMandatory: function (vehicle) {
      if(!vehicle.Rego && !vehicle.Serial) {
        return true;
      }

      if(vehicle.Rego && !vehicle.Serial) {
        const rego = vehicle.Rego.toUpperCase();
        return rego === 'UNREG' || rego === 'UNREGIS' || rego === 'UNREGISTERED';
      }
      return false;
    },

    isSerialMandatory: function (vehicle) {
      if(!vehicle.Rego && !vehicle.VIN) {
        return true;
      }

      if(vehicle.Rego && !vehicle.VIN) {
        const rego = vehicle.Rego.toUpperCase();
        return rego === 'UNREG' || rego === 'UNREGISTERED';
      }
      return false;
    },

    isMakeModelYearMandatory: function (vehicle) {
      if(this.mandatory) {
        return true;
      }
      const types = ['Camper Trailer', 'Caravan', 'Motorhome', 'Prime Mover', 'Trailer', 'Rigid/articulated - 5 - 10t', 'Rigid/articulated - Over 10t', 'Other'];
      if(vehicle.Type) {
        const vehicleType = vehicle.Type.name;
        return types.includes(vehicleType);
      }
      return false;
    }
  }
};
</script>
